import {
  getLocaleFromNavigator,
  getLocaleFromQueryString,
  init,
  locale,
  register
} from 'svelte-i18n';

export const languages = [
  { name: 'English', code: 'en' },
  { name: 'Deutsch', code: 'de' },
  { name: 'Italiano', code: 'it' },
  { name: 'Français', code: 'fr' }
];

const supportedLocales = languages.map((language) => language.code);
const defaultLocale = 'en';

locale.set(defaultLocale);

supportedLocales.forEach((locale) => {
  register(locale, () => import(`./locales/${locale}.json`));
});

let currentLocale = getLocaleFromQueryString('lang') ?? getLocaleFromNavigator() ?? defaultLocale;
if (currentLocale.indexOf('-') > -1) {
  currentLocale = currentLocale.split('-')[0];
}
if (!supportedLocales.includes(currentLocale)) {
  currentLocale = defaultLocale;
}

init({
  fallbackLocale: defaultLocale,
  initialLocale: currentLocale
});
